import { set } from "lodash";
import Kithara from "src/services/kithara";
const kithara = new Kithara();

export default {
  state: {
    list: {
      loading: false,
      complete: false,
      errors: [],
      teamSongs: [],
      nextPage: 1,
      pageSize: 40,
      filters: {
        main: "",
        tags: []
      }
    },
    editing: {
      pending: false,
      errors: [],
      teamSong: {}
    }
  },
  mutations: {
    TEAM_SONGS_LIST_CLEAN: state => {
      state.list.teamSongs = [];
      state.list.nextPage = 1;
      state.list.complete = false;
    },
    TEAM_SONGS_LIST: state => {
      state.list.loading = true;
    },
    TEAM_SONGS_LIST_FILTER: (state, payload) => {
      state.list.filters = payload;
    },
    TEAM_SONGS_LIST_SUCCESS: (state, payload) => {
      state.list.loading = false;
      state.list.teamSongs = payload.teamSongs;
      state.list.complete = payload.complete;
      state.list.nextPage++;
    },
    TEAM_SONGS_LIST_FAILED: (state, payload) => {
      state.list.loading = false;
      state.list.errors = payload;
    },
    TEAM_SONGS_SELECT: state => {
      state.editing.teamSong = {};
    },
    TEAM_SONGS_SET_SELECTED: (state, payload) => {
      state.editing.teamSong = payload;
    },
    TEAM_SONGS_UPDATE_SELECTED: (state, { path, value }) => {
      set(state.editing.teamSong, path, value);
    },
    TEAM_SONGS_SELECT_FAILED: () => {
      // do nothing because it should not happen
    },
    TEAM_SONGS_UPDATE: state => {
      state.editing.pending = true;
    },
    TEAM_SONGS_UPDATE_SUCCESS: state => {
      state.editing.pending = false;
    },
    TEAM_SONGS_UPDATE_FAILED: (state, payload) => {
      state.editing.pending = false;
      state.editing.errors = payload;
    }
  },
  actions: {
    changeTeamSongsFilter({ commit, rootState }, payload) {
      if (!payload) {
        payload = { main: rootState.route.query.filter, tags: [] };
      }
      commit("TEAM_SONGS_LIST_CLEAN");
      commit("TEAM_SONGS_LIST_FILTER", payload);
      commit("SONGS_LIST_CLEAN");
      commit("SONGS_LIST_FILTER", payload);
    },
    refreshTeamSongs({ commit }) {
      commit("TEAM_SONGS_LIST_CLEAN");
    },
    loadMoreTeamSongs({ state, commit }) {
      if (!state.list.loading && !state.list.complete) {
        commit("TEAM_SONGS_LIST");
        const { nextPage, pageSize, filters } = state.list;
        return kithara
          .getTeamSongs(1, nextPage, pageSize, "title|asc", filters)
          .then(response => {
            const { data } = response.data;
            const lastPage = response.data.links.pagination.last_page;
            commit("TEAM_SONGS_LIST_SUCCESS", {
              teamSongs: state.list.teamSongs.concat(data),
              complete: lastPage === 0 || nextPage === lastPage
            });
            return data;
          })
          .catch(err => commit("TEAM_SONGS_LIST_FAILED", [err]));
      } else return [];
    },
    loadAllTeamSongs({ state, commit }) {
      if (!state.list.loading && !state.list.complete) {
        commit("TEAM_SONGS_LIST");
        const { nextPage, filters } = state.list;
        return kithara
          .getTeamSongs(1, nextPage, -1, "title|asc", filters)
          .then(response => {
            const { data } = response.data;
            const lastPage = response.data.links.pagination.last_page;
            commit("TEAM_SONGS_LIST_SUCCESS", {
              teamSongs: state.list.teamSongs.concat(data),
              complete: lastPage === 0 || nextPage === lastPage
            });
            return data;
          })
          .catch(err => commit("TEAM_SONGS_LIST_FAILED", [err]));
      } else return [];
    },
    selectTeamSong({ commit, rootState }) {
      commit("TEAM_SONGS_SELECT");
      return kithara
        .getTeamSong(1, rootState.route.params.id)
        .then(response => {
          commit("TEAM_SONGS_SET_SELECTED", response.data);
        })
        .catch(err => commit("TEAM_SONGS_SELECT_FAILED", [err]));
    },
    clearTeamSong({ commit }) {
      commit("TEAM_SONGS_SELECT");
    },
    createTeamSong({ state, commit }) {
      commit("TEAM_SONGS_UPDATE");
      return kithara
        .createTeamSong(1, state.editing.teamSong)
        .then(() => {
          commit("TEAM_SONGS_UPDATE_SUCCESS");
          commit("TEAM_SONGS_LIST_CLEAN");
        })
        .catch(err => commit("TEAM_SONGS_UPDATE_FAILED", [err]));
    },
    saveTeamSong({ state, commit, rootState }) {
      commit("TEAM_SONGS_UPDATE");
      return kithara
        .updateTeamSong(1, rootState.route.params.id, state.editing.teamSong)
        .then(() => {
          commit("TEAM_SONGS_UPDATE_SUCCESS");
          commit("TEAM_SONGS_LIST_CLEAN");
        })
        .catch(err => commit("TEAM_SONGS_UPDATE_FAILED", [err]));
    },
    deleteTeamSong({ commit, rootState }) {
      commit("TEAM_SONGS_UPDATE");
      return kithara
        .deleteTeamSong(1, rootState.route.params.id)
        .then(() => {
          commit("TEAM_SONGS_UPDATE_SUCCESS");
          commit("TEAM_SONGS_SELECT");
          commit("TEAM_SONGS_LIST_CLEAN");
        })
        .catch(err => commit("TEAM_SONGS_UPDATE_FAILED", [err]));
    },
    updateSelectedTeamSong({ commit }, { path, value }) {
      commit("TEAM_SONGS_UPDATE_SELECTED", { path, value });
    }
  },
  getters: {
    teamSongs: state => state.list.teamSongs,
    teamSongsFilter: state => state.list.filters.main,
    teamSongsLoading: state => state.list.loading,
    teamSongsComplete: state => state.list.complete,
    selectedTeamSong: state => state.editing.teamSong
  }
};



// WEBPACK FOOTER //
// ./src/store/teamSongs.js